(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (window.__ziorQAModalInit) return;
  window.__ziorQAModalInit = true;

  /* ─── Cart utilities ─── */
  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart__count').forEach(function (el) {
          if (el.tagName !== 'INPUT') el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cart }));
        document.body.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: cart }));
      })
      .catch(function () {});
  }

  function ajaxAdd(variantId, qty, onSuccess, onError) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { onError(data.description || 'Error'); }
        else { refreshCart(); onSuccess(); }
      })
      .catch(function () { onError('Error'); });
  }

  function formatMoney(cents) {
    var n = cents / 100;
    return n % 1 === 0 ? n.toLocaleString() : n.toFixed(2);
  }

  /* ─── Build modal DOM ─── */
  var modal = document.createElement('div');
  modal.className = 'zior-qam';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-hidden', 'true');
  modal.innerHTML =
    '<div class="zior-qam__overlay"></div>' +
    '<div class="zior-qam__panel">' +
      '<div class="zior-qam__header">' +
        '<div class="zior-qam__product-info">' +
          '<img class="zior-qam__img" src="" alt="" loading="lazy">' +
          '<div><p class="zior-qam__title"></p><p class="zior-qam__price"></p></div>' +
        '</div>' +
        '<button type="button" class="zior-qam__close" aria-label="Close">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="zior-qam__opts"></div>' +
      '<div class="zior-qam__footer">' +
        '<button type="button" class="zior-qam__atc" disabled>' +
          '<span class="zior-qam__atc-label"></span>' +
        '</button>' +
        '<p class="zior-qam__msg" aria-live="polite"></p>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);

  var qPanel   = modal.querySelector('.zior-qam__panel');
  var qImg     = modal.querySelector('.zior-qam__img');
  var qTitle   = modal.querySelector('.zior-qam__title');
  var qPrice   = modal.querySelector('.zior-qam__price');
  var qOpts    = modal.querySelector('.zior-qam__opts');
  var qAtc     = modal.querySelector('.zior-qam__atc');
  var qAtcLbl  = modal.querySelector('.zior-qam__atc-label');
  var qMsg     = modal.querySelector('.zior-qam__msg');

  var currentProduct   = null;
  var selectedOptions  = [];
  var cfg              = {};

  /* ─── Variant logic ─── */
  function getVariant() {
    if (!currentProduct) return null;
    return currentProduct.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selectedOptions[i]; });
    }) || null;
  }

  function updateVariantUI() {
    var v = getVariant();
    if (v) {
      qPrice.textContent = formatMoney(v.price);
      if (v.available) {
        qAtc.disabled = false;
        qAtc.dataset.vid = v.id;
        qAtcLbl.textContent = cfg.atcLabel || 'Add to cart';
      } else {
        qAtc.disabled = true;
        delete qAtc.dataset.vid;
        qAtcLbl.textContent = cfg.unavailLabel || 'Unavailable';
      }
    } else {
      qAtc.disabled = true;
      delete qAtc.dataset.vid;
      qAtcLbl.textContent = cfg.atcLabel || 'Add to cart';
    }
    /* dim unavailable option buttons */
    qOpts.querySelectorAll('.zior-qam__opt-group').forEach(function (grp) {
      var oi = parseInt(grp.dataset.oi, 10);
      grp.querySelectorAll('.zior-qam__opt-btn').forEach(function (btn) {
        var test = selectedOptions.slice();
        test[oi] = btn.dataset.val;
        var avail = currentProduct.variants.some(function (v) {
          return v.available && v.options.every(function (o, i) {
            return test[i] == null || o === test[i];
          });
        });
        btn.classList.toggle('zior-qam__opt-btn--unavail', !avail);
      });
    });
  }

  function buildOptions() {
    if (!currentProduct) return;
    var html = '';
    var hasRealOptions = !currentProduct.has_only_default_variant && currentProduct.options && currentProduct.options.length > 0;
    if (hasRealOptions) {
      currentProduct.options.forEach(function (optName, oi) {
        var vals = [];
        currentProduct.variants.forEach(function (v) {
          if (v.options[oi] && vals.indexOf(v.options[oi]) === -1) vals.push(v.options[oi]);
        });
        html += '<div class="zior-qam__opt-group" data-oi="' + oi + '">';
        html += '<p class="zior-qam__opt-name">' + optName + '</p>';
        html += '<div class="zior-qam__opt-values">';
        vals.forEach(function (val) {
          html += '<button type="button" class="zior-qam__opt-btn" data-val="' + val.replace(/"/g, '&quot;') + '">' + val + '</button>';
        });
        html += '</div></div>';
      });
    }
    qOpts.innerHTML = html;

    /* Pre-select first available variant */
    var first = currentProduct.variants.find(function (v) { return v.available; }) || currentProduct.variants[0];
    if (first) {
      selectedOptions = first.options.slice();
      qOpts.querySelectorAll('.zior-qam__opt-group').forEach(function (grp) {
        var oi = parseInt(grp.dataset.oi, 10);
        grp.querySelectorAll('.zior-qam__opt-btn').forEach(function (btn) {
          if (btn.dataset.val === selectedOptions[oi]) btn.classList.add('zior-qam__opt-btn--active');
        });
      });
    } else {
      selectedOptions = currentProduct.options ? currentProduct.options.map(function () { return null; }) : [];
    }
  }

  /* ─── Open / close ─── */
  function openModal(product, modalCfg) {
    currentProduct = product;
    cfg = modalCfg || {};

    /* Apply panel CSS vars */
    qPanel.style.setProperty('--zqam-width', (cfg.modalWidth || 420) + 'px');
    qPanel.style.setProperty('--zqam-radius', (cfg.modalRadius != null ? cfg.modalRadius : 16) + 'px');
    if (cfg.modalBg)     qPanel.style.setProperty('--zqam-bg',      cfg.modalBg);
    else                 qPanel.style.removeProperty('--zqam-bg');
    if (cfg.modalColor)  qPanel.style.setProperty('--zqam-clr',     cfg.modalColor);
    else                 qPanel.style.removeProperty('--zqam-clr');
    if (cfg.modalBtnBg)  qPanel.style.setProperty('--zqam-btn-bg',  cfg.modalBtnBg);
    else                 qPanel.style.removeProperty('--zqam-btn-bg');
    if (cfg.modalBtnColor) qPanel.style.setProperty('--zqam-btn-clr', cfg.modalBtnColor);
    else                   qPanel.style.removeProperty('--zqam-btn-clr');

    modal.classList.toggle('zior-qam--center', cfg.modalPosition === 'center');

    /* Image */
    if (product.image && cfg.showImage !== false) {
      qImg.src = product.image;
      qImg.alt = product.title || '';
      qImg.style.display = '';
    } else {
      qImg.style.display = 'none';
    }

    qTitle.textContent = product.title || '';
    qMsg.textContent = '';
    buildOptions();
    updateVariantUI();

    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('zior-qam--open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { qAtc.focus(); }, 80);
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('zior-qam--open');
    document.body.style.overflow = '';
    currentProduct = null;
    selectedOptions = [];
  }

  /* ─── Event delegation ─── */
  document.addEventListener('click', function (e) {

    /* Open modal */
    var qaBtn = e.target.closest('[data-zior-qa-full]');
    if (qaBtn) {
      e.preventDefault();
      var pid = qaBtn.dataset.productId;
      var jsonEl = document.querySelector('.zior-qa-json[data-for="' + pid + '"]');
      if (!jsonEl) return;
      var parsed;
      try { parsed = JSON.parse(jsonEl.textContent); } catch (_) { return; }
      openModal(parsed.product, parsed.cfg);
      return;
    }

    /* Close */
    if (e.target.closest('.zior-qam__overlay') || e.target.closest('.zior-qam__close')) {
      closeModal();
      return;
    }

    /* Option select */
    var optBtn = e.target.closest('.zior-qam__opt-btn');
    if (optBtn && modal.classList.contains('zior-qam--open')) {
      var grp = optBtn.closest('.zior-qam__opt-group');
      var oi  = parseInt(grp.dataset.oi, 10);
      grp.querySelectorAll('.zior-qam__opt-btn').forEach(function (b) { b.classList.remove('zior-qam__opt-btn--active'); });
      optBtn.classList.add('zior-qam__opt-btn--active');
      selectedOptions[oi] = optBtn.dataset.val;
      updateVariantUI();
      return;
    }

    /* Add to cart */
    var atcBtn = e.target.closest('.zior-qam__atc');
    if (atcBtn && !atcBtn.disabled && atcBtn.dataset.vid) {
      var origLbl = qAtcLbl.textContent;
      atcBtn.disabled = true;
      ajaxAdd(atcBtn.dataset.vid, 1, function () {
        qAtcLbl.textContent = '✓';
        qMsg.textContent = '';
        setTimeout(function () { closeModal(); qAtcLbl.textContent = origLbl; }, 900);
      }, function (err) {
        qMsg.textContent = err || 'Error';
        qAtcLbl.textContent = origLbl;
        atcBtn.disabled = false;
      });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('zior-qam--open')) closeModal();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shp-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (window.__ziorQAModalInit) return;
  window.__ziorQAModalInit = true;

  function refreshCart() {
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('[data-cart-count],.cart-count-bubble span,.cart__count').forEach(function(el){
        if(el.tagName!=='INPUT') el.textContent=cart.item_count;
      });
      document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:cart}));
      document.body.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:cart}));
    }).catch(function(){});
  }

  function ajaxAdd(variantId,qty,onSuccess,onError){
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:parseInt(variantId,10),quantity:qty||1})})
      .then(function(r){return r.json();}).then(function(data){
        if(data.status){onError(data.description||'Error');}else{refreshCart();onSuccess();}
      }).catch(function(){onError('Error');});
  }

  function formatMoney(cents){var n=cents/100;return n%1===0?n.toLocaleString():n.toFixed(2);}

  var modal=document.createElement('div');
  modal.className='zior-qam';
  modal.setAttribute('role','dialog');
  modal.setAttribute('aria-modal','true');
  modal.setAttribute('aria-hidden','true');
  modal.innerHTML='<div class="zior-qam__overlay"></div><div class="zior-qam__panel"><div class="zior-qam__header"><div class="zior-qam__product-info"><img class="zior-qam__img" src="" alt="" loading="lazy"><div><p class="zior-qam__title"></p><p class="zior-qam__price"></p></div></div><button type="button" class="zior-qam__close" aria-label="Close"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div><div class="zior-qam__fabric" style="display:none"><p class="zior-qam__fabric-label">FABRIC</p><span class="zior-qam__fabric-chip"></span></div><div class="zior-qam__opts"></div><div class="zior-qam__footer"><button type="button" class="zior-qam__atc" disabled><span class="zior-qam__atc-label"></span></button><p class="zior-qam__msg" aria-live="polite"></p></div></div>';
  document.body.appendChild(modal);

  var qPanel=modal.querySelector('.zior-qam__panel'),qImg=modal.querySelector('.zior-qam__img'),qTitle=modal.querySelector('.zior-qam__title'),qPrice=modal.querySelector('.zior-qam__price'),qFabric=modal.querySelector('.zior-qam__fabric'),qFabricChip=modal.querySelector('.zior-qam__fabric-chip'),qOpts=modal.querySelector('.zior-qam__opts'),qAtc=modal.querySelector('.zior-qam__atc'),qAtcLbl=modal.querySelector('.zior-qam__atc-label'),qMsg=modal.querySelector('.zior-qam__msg');
  var currentProduct=null,selectedOptions=[],cfg={};

  function getVariant(){if(!currentProduct)return null;return currentProduct.variants.find(function(v){return v.options.every(function(o,i){return o===selectedOptions[i];});;})||null;}

  function updateVariantUI(){
    var v=getVariant();
    if(v){
      qPrice.textContent=formatMoney(v.price);
      if(v.available){qAtc.disabled=false;qAtc.dataset.vid=v.id;qAtcLbl.textContent=cfg.atcLabel||'Add to cart';}
      else{qAtc.disabled=true;delete qAtc.dataset.vid;qAtcLbl.textContent=cfg.unavailLabel||'Unavailable';}
    }else{qAtc.disabled=true;delete qAtc.dataset.vid;qAtcLbl.textContent=cfg.atcLabel||'Add to cart';}
    qOpts.querySelectorAll('.zior-qam__opt-group').forEach(function(grp){
      var oi=parseInt(grp.dataset.oi,10);
      grp.querySelectorAll('.zior-qam__opt-btn').forEach(function(btn){
        var test=selectedOptions.slice();test[oi]=btn.dataset.val;
        var avail=currentProduct.variants.some(function(v){return v.available&&v.options.every(function(o,i){return test[i]==null||o===test[i];});});
        btn.classList.toggle('zior-qam__opt-btn--unavail',!avail);
      });
    });
  }

  function buildOptions(){
    if(!currentProduct)return;
    var html='';
    var hasReal=!currentProduct.has_only_default_variant&&currentProduct.options&&currentProduct.options.length>0;
    if(hasReal){
      currentProduct.options.forEach(function(optName,oi){
        var vals=[];currentProduct.variants.forEach(function(v){if(v.options[oi]&&vals.indexOf(v.options[oi])===-1)vals.push(v.options[oi]);});
        html+='<div class="zior-qam__opt-group" data-oi="'+oi+'"><p class="zior-qam__opt-name">'+optName+'</p><div class="zior-qam__opt-values">';
        vals.forEach(function(val){html+='<button type="button" class="zior-qam__opt-btn" data-val="'+val.replace(/"/g,'&quot;')+'">'+val+'</button>';});
        html+='</div></div>';
      });
    }
    qOpts.innerHTML=html;
    var first=currentProduct.variants.find(function(v){return v.available;})||currentProduct.variants[0];
    if(first){
      selectedOptions=first.options.slice();
      qOpts.querySelectorAll('.zior-qam__opt-group').forEach(function(grp){
        var oi=parseInt(grp.dataset.oi,10);
        grp.querySelectorAll('.zior-qam__opt-btn').forEach(function(btn){if(btn.dataset.val===selectedOptions[oi])btn.classList.add('zior-qam__opt-btn--active');});
      });
    }else{selectedOptions=currentProduct.options?currentProduct.options.map(function(){return null;}):[]; }
  }

  function openModal(product,modalCfg){
    currentProduct=product;cfg=modalCfg||{};
    qPanel.style.setProperty('--zqam-width',(cfg.modalWidth||420)+'px');
    qPanel.style.setProperty('--zqam-radius',(cfg.modalRadius!=null?cfg.modalRadius:16)+'px');
    if(cfg.modalBg)qPanel.style.setProperty('--zqam-bg',cfg.modalBg);else qPanel.style.removeProperty('--zqam-bg');
    if(cfg.modalColor)qPanel.style.setProperty('--zqam-clr',cfg.modalColor);else qPanel.style.removeProperty('--zqam-clr');
    if(cfg.modalBtnBg)qPanel.style.setProperty('--zqam-btn-bg',cfg.modalBtnBg);else qPanel.style.removeProperty('--zqam-btn-bg');
    if(cfg.modalBtnColor)qPanel.style.setProperty('--zqam-btn-clr',cfg.modalBtnColor);else qPanel.style.removeProperty('--zqam-btn-clr');
    modal.classList.toggle('zior-qam--center',cfg.modalPosition==='center');
    if(product.image&&cfg.showImage!==false){qImg.src=product.image;qImg.alt=product.title||'';qImg.style.display='';}else{qImg.style.display='none';}
    qTitle.textContent=product.title||'';qMsg.textContent='';
    if(product.fabric){qFabricChip.textContent=product.fabric;qFabric.style.display='';}else{qFabric.style.display='none';}
    buildOptions();updateVariantUI();
    modal.setAttribute('aria-hidden','false');modal.classList.add('zior-qam--open');document.body.style.overflow='hidden';
    setTimeout(function(){qAtc.focus();},80);
  }

  function closeModal(){
    modal.setAttribute('aria-hidden','true');modal.classList.remove('zior-qam--open');document.body.style.overflow='';currentProduct=null;selectedOptions=[];
  }

  document.addEventListener('click',function(e){
    var qaBtn=e.target.closest('[data-zior-qa-full]');
    if(qaBtn){
      e.preventDefault();
      var pid=qaBtn.dataset.productId;
      var jsonEl=document.querySelector('.zior-qa-json[data-for="'+pid+'"]');
      if(!jsonEl)return;
      var parsed;try{parsed=JSON.parse(jsonEl.textContent);}catch(_){return;}
      openModal(parsed.product,parsed.cfg);return;
    }
    if(e.target.closest('.zior-qam__overlay')||e.target.closest('.zior-qam__close')){closeModal();return;}
    var optBtn=e.target.closest('.zior-qam__opt-btn');
    if(optBtn&&modal.classList.contains('zior-qam--open')){
      var grp=optBtn.closest('.zior-qam__opt-group');var oi=parseInt(grp.dataset.oi,10);
      grp.querySelectorAll('.zior-qam__opt-btn').forEach(function(b){b.classList.remove('zior-qam__opt-btn--active');});
      optBtn.classList.add('zior-qam__opt-btn--active');selectedOptions[oi]=optBtn.dataset.val;updateVariantUI();return;
    }
    var atcBtn=e.target.closest('.zior-qam__atc');
    if(atcBtn&&!atcBtn.disabled&&atcBtn.dataset.vid){
      var origLbl=qAtcLbl.textContent;atcBtn.disabled=true;
      ajaxAdd(atcBtn.dataset.vid,1,function(){qAtcLbl.textContent='✓';qMsg.textContent='';setTimeout(function(){closeModal();qAtcLbl.textContent=origLbl;},900);},function(err){qMsg.textContent=err||'Error';qAtcLbl.textContent=origLbl;atcBtn.disabled=false;});
      return;
    }
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('zior-qam--open'))closeModal();});
})();
  } catch(e) { console.error(e); }
})();

})();
